import React from 'react';
import { ProjetosEnum } from '../../Shared/Enums/ProjetosEnum';
import './styles.scss';

export default function Paginacao(props) {
    const subMenu = props && props.paginacao ? props.paginacao : null;
    if (!subMenu) return null;

    /* Limita esta paginacao apenas para a visao cliente */
    if (Number(subMenu.projeto) !== ProjetosEnum.PLATAFORMA_CLIENTE) return null;

    const id = subMenu.id != null ? subMenu.id : null;
    const texto = subMenu.texto ? String(subMenu.texto) : '';


    if (id === null || !texto) return null;

    return (
        <footer className="p-rodape">
            <strong className="app-footer__value">
                {id} - {texto}
            </strong>
        </footer>
    );
}
